import { z } from "zod"
import {
  InvoiceListSchema,
  InvoiceSchema,
  RequestAutoPaymentReqSchema,
  RequestBillingKeyReqSchema,
  UnsettledPaymentReqSchema,
} from "./payment.schema"

export enum InvoiceTypeEnum {
  MtMonthlyPayment = "MtMonthlyPayment", // OOO 플랜 정기구독
  MtAdditionalCharge = "MtAdditionalCharge", // 추가 사용량 후불 청구
  MtSubscriptionUpgrade = "MtSubscriptionUpgrade", // OOO 플랜 업그레이드
  ApiMonthlyPayment = "ApiMonthlyPayment",
  ApiAdditionalPayment = "ApiAdditionalPayment",
}

export enum InvoiceStatusEnum {
  Completed = "completed",
  Canceled = "canceled",
  PartiallyRefunded = "partially_refunded",
}

export enum PaymentGatewayEnum {
  Toss = "toss",
  Stripe = "stripe",
}

export enum CurrencyEnum {
  Krw = "krw",
  Usd = "usd",
}

export enum CurrencyUnitEnum {
  Krw = "₩",
  Usd = "$",
}

export type InvoiceList = z.infer<typeof InvoiceListSchema>
export type Invoice = z.infer<typeof InvoiceSchema>
export type UnsettledPayment = z.infer<typeof UnsettledPaymentReqSchema>
export type RequestBillingKeyReq = z.infer<typeof RequestBillingKeyReqSchema>
export type RequestAutoPaymentReq = z.infer<typeof RequestAutoPaymentReqSchema>
